const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const TournamentCycle = () => import(/* webpackChunkName: "tournament" */ './cycle/view/index.vue');
const TournamentLeaderboardAdd = () => import(/* webpackChunkName: "tournament" */ './leaderboard/view/add.vue');
const TournamentLeaderboardDetail = () => import(/* webpackChunkName: "tournament" */ './leaderboard/view/detail.vue');
const TournamentLeaderboardEdit = () => import(/* webpackChunkName: "tournament" */ './leaderboard/view/edit.vue');
const TournamentLeaderboardList = () => import(/* webpackChunkName: "tournament" */ './leaderboard/view/index.vue');
const TournamentLeaderboardMedal = () => import(/* webpackChunkName: "tournament" */ './leaderboard/view/medal.vue');
const TournamentMedalAdd = () => import(/* webpackChunkName: "tournament" */ './medal/view/add.vue');
const TournamentMedalEdit = () => import(/* webpackChunkName: "tournament" */ './medal/view/edit.vue');
const TournamentMedalList = () => import(/* webpackChunkName: "tournament" */ './medal/view/index.vue');

export const ROUTE_NAME_TOURNAMENT = {
    CYCLE: 'TournamentCycle',
    LEADERBOARD: {
        INDEX: 'TournamentLeaderboardList',
        ADD: 'TournamentLeaderboardAdd',
        EDIT: 'TournamentLeaderboardEdit',
        DETAIL: 'TournamentLeaderboardDetail',
        MEDAL: 'TournamentLeaderboardMedal'
    },
    MEDAL: {
        INDEX: 'TournamentMedalList',
        ADD: 'TournamentMedalAdd',
        EDIT: 'TournamentMedalEdit'
    }
} as const;

export default [
    {
        path: '/app/:appId/tournament/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'cycle/',
                name: ROUTE_NAME_TOURNAMENT.CYCLE,
                component: TournamentCycle,
                meta: { requiresAuth: true }
            },
            {
                path: 'leaderboard/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX,
                        component: TournamentLeaderboardList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.ADD,
                        component: TournamentLeaderboardAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.EDIT,
                        component: TournamentLeaderboardEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.DETAIL,
                        component: TournamentLeaderboardDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/medal',
                        name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.MEDAL,
                        component: TournamentLeaderboardMedal,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'medal/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_TOURNAMENT.MEDAL.INDEX,
                        component: TournamentMedalList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_TOURNAMENT.MEDAL.ADD,
                        component: TournamentMedalAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_TOURNAMENT.MEDAL.EDIT,
                        component: TournamentMedalEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
